import { render, staticRenderFns } from "./buttonCollapse.vue?vue&type=template&id=aa2e17da&"
import script from "./buttonCollapse.vue?vue&type=script&lang=js&"
export * from "./buttonCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports